module.exports = __webpack_public_path__ + "od-upload-icon/od-upload-icon-53ddec16ca4f35df0794603523fd7b15.svg";